import VerticalBookingCardBase from '../common/VerticalBookingCardBase';
import { extractUpgradeSymbols } from '../../../../util/upgradeSymbolsHelper';
import { generateUniqueColor } from '../../../../util/colorUtil';
import { formatOrderedResourcesByGroup } from '../../../../util/orderedResourcesDisplay';

function BookingCardBashv2({
  booking,
  handleOpenModal,
  durationByIdMs,
  orderedResourcesConfig,
}) {
  const color = generateUniqueColor(String(booking?._id || ''));

  const upgradeSymbols = extractUpgradeSymbols(booking);
  const orderedLine = formatOrderedResourcesByGroup(booking, orderedResourcesConfig?.nameById, {
    maxParts: 2,
  });

  const handleCardClick = () => {
    if (handleOpenModal) {
      handleOpenModal(booking._id, color);
    }
  };

  return (
    <VerticalBookingCardBase
      booking={booking}
      color={'#cccccc'}
      onCardClick={handleCardClick}
      showProductInfo={false}
      showVariationInfo={false}
      iconProps={{
        upgrades: upgradeSymbols,
        manualUpgrades: [],
        participantCount: booking.participantCount,
        color: '#2d2d2d',
      }}
    >
      {/* show details inside card for internal vertical view */}
      {orderedLine ? (
        <div style={{ fontSize: '75%', opacity: 0.85, marginTop: 2 }}>{orderedLine}</div>
      ) : booking.pricingName ? (
        <div style={{ fontSize: '80%', opacity: 0.85, marginTop: 2 }}>{booking.pricingName}</div>
      ) : null}
      {booking.resourceId?.name && (
        <div style={{ fontSize: '80%', opacity: 0.8 }}>{booking.resourceId.name}</div>
      )}
    </VerticalBookingCardBase>
  );
}

export default BookingCardBashv2;
